"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomeValuationInformationSource = void 0;
var HomeValuationInformationSource;
(function (HomeValuationInformationSource) {
    HomeValuationInformationSource["CORE_LOGIC_MARKETING_SNAPSHOT"] = "CORE_LOGIC_MARKETING_SNAPSHOT";
    HomeValuationInformationSource["HOUSE_CANARY"] = "HOUSE_CANARY";
    HomeValuationInformationSource["AVEN_ADVISOR_LIEN_INFO"] = "AVEN_ADVISOR_LIEN_INFO";
})(HomeValuationInformationSource || (exports.HomeValuationInformationSource = HomeValuationInformationSource = {}));
